import { Link } from "react-router-dom";
import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/cartReducer";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { AuthContext } from "../../context/AuthContext";
import "./Card.scss";
import { Cpu } from "lucide-react";
import { toast } from "react-toastify";

const Card = ({ item }) => {
  const dispatch = useDispatch();
  const { buyer } = useContext(AuthContext);

  //console.log("item", item);

  const products = useSelector((state) => state.cart.products);
  const cartItem = products.find((i) => i.id === item._id);
  const inCart = !!cartItem;

  // find special price for this buyer
  const customerSpecialPrice = item.customerPrice?.find(
    (cp) => cp.customerId === buyer?.buyerId
  );

  const handleAddToCart = () => {
    dispatch(
      addToCart({
        id: item._id,
        title: item.name,
        desc: item.desc,
        weight: item.weight,
        price: customerSpecialPrice ? customerSpecialPrice?.price : item.price,
        img: item.proPhotos[0],
        quantity: 5,
      })
    );
    toast.success("Product added to cart!");
  };

  return (
    <div className="card">
      <div className="card_in">
        <div className="image">
          <Link to={`/product/${item._id}`}>
            {item.discount && (
              <span className="badge discount">{item.discoamount}% OFF</span>
            )}
            {item.outofstock && (
              <span className="badge outofstock">Out of Stock</span>
            )}
            <img
              src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${item.proPhotos[0]}`}
              alt={item.name}
              className="mainImg"
            />
            {item.proPhotos[1] && (
              <img
                src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${item.proPhotos[1]}`}
                alt={`${item.name} hover`}
                className="secondImg"
              />
            )}
          </Link>
        </div>

        <div className="data">
          <div className="proName">
            <p className="product-name">{item.name}</p>
            <small style={{ fontSize: "12px", color: "#888" }}>
              Minimum Order <br /> Quantity: 5 kg |{" "}
              {customerSpecialPrice ? (
                <span>{(5 * customerSpecialPrice.price).toFixed(2)} AED</span>
              ) : (
                <span>{(5 * item.price).toFixed(2)} AED</span>
              )}{" "}
            </small>
          </div>
          {/* <small className="product-weight">Weight: {item.weight}</small> */}

          {/* <div className="prices">
              <span className="price">AED {item?.price?.toFixed(2)}</span>
            </div> */}

          <div className="addToCard">
            <div className="prices">
              {customerSpecialPrice ? (
                <>
                  <span>1Kg</span>
                  <span
                    className={customerSpecialPrice ? "descountPrice" : "price"}
                  >
                    <em> AED</em> {customerSpecialPrice.price?.toFixed(2)}
                  </span>
                </>
              ) : (
                <>
                  <span>1Kg</span>
                  <span className="price">
                    {" "}
                    <em> AED</em> {item.price?.toFixed(2)}
                  </span>
                </>
              )}
            </div>

            <button
              className={`addtocart ${inCart ? "inCart" : ""}`}
              onClick={handleAddToCart}
              disabled={item.outofstock}
            >
              {inCart ? "In Cart" : "Add to Cart"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
